export default function RegularCell({ value }) {
    return value ? 'Regular' : 'Not regular';
}
